import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import GetUserId from 'Components/UserLogged/UserId/UserId';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import Button from 'Components/Button/Button';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';
import FilterItemCost from '../FilterItemCost/FilterItemCost';
import useUpdateEffect from 'Components/UseUpdateEffect/useUpdateEffect';

const ItemCost = ({
    itemCostIdSelected,
    isActiveFilterItems,
    comboBoxYear,
    reloadItemCost,
    onUpdateItemCostIdsSelected,
    onUpdateShowFilterMonthPanelItem,
    onUpdateShowHistoryChangePanel,
    onUpdateShowItemsYearReplicate,
    onUpdateReloadItemCost,
    showFilterMonthPanelItem,
    onUpdateIsActiveFilterItems,
    onUpdateComboBoxYear,
    showItemsYearReplicate,
    showHistoryChangePanel
}) => {
    const userIdLogged = GetUserId()
    const [idItemCost, setIdItemCost] = useState(null)
    const [identifier, setIdentifier] = useState(null)
    const [dsItem, setDsItem] = useState(null)
    const [sequenceId, setSequenceId] = useState(null)
    const [isActive, setIsActive] = useState('S')
    const [username, setUsername] = useState(null)
    const [updateDate, setUpdateDate] = useState(null)
    const [dsItemChanged, setDsItemChanged] = useState(null)
    const [budgetLimit, setBudgetLimit] = useState(null)
    const [isAddAnnualBudget, setAddAnnualBudget] = useState('N')
    const [dtStartUpdateItemCost, setDtStartUpdateItemCost] = useState(null)
    const [dtFinishUpdateItemCost, setDtFinishUpdateItemCost] = useState(null)

    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);

    const [recordsItemCost, setRecordsItemCost] = useState(null);
    const [itemCostList, setItemCostList] = useState(null);
    const [loadingItemCostList, setLoadingItemCostList] = useState(false);

    const readOnlyAttributes = !(inserting || updating);

    const messageIsChangeItemCost = () => {
        if (inserting) {
            return ('Inserir orçamento detalhado')
        } else {
            return ('Atualizar orçamento detalhado')
        }
    }

    const attributeList = [
        { name: "id", value: idItemCost, setter: setIdItemCost },
        { name: "identifier", value: identifier, setter: setIdentifier },
        { name: "dsItem", value: dsItem, setter: setDsItem },
        { name: "dsItemChanged", value: dsItemChanged, setter: setDsItemChanged },
        { name: "idSequence", value: sequenceId, setter: setSequenceId },
        { name: "budgetLimit", value: budgetLimit, setter: setBudgetLimit },
        {
            name: "isActive",
            value: isActive,
            setter: setIsActive,
            resetValue: 'S',
            checks: [
                { field: 'isActive', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        { name: "username", value: username, setter: setUsername },
        { name: "dtUpdate", value: updateDate, setter: setUpdateDate },
        {
            name: "isAddAnnualBudget",
            value: isAddAnnualBudget,
            setter: setAddAnnualBudget,
            customMessage: messageIsChangeItemCost(),
            isVisible: true
        },
        { name: "startDate", value: dtStartUpdateItemCost, setter: setDtStartUpdateItemCost, isVisible: (isAddAnnualBudget === 'S'), isMandatory: (isAddAnnualBudget === 'S' ? 'S' : 'N') },
        { name: "endDate", value: dtFinishUpdateItemCost, setter: setDtFinishUpdateItemCost, isVisible: (isAddAnnualBudget === 'S'), isMandatory: (isAddAnnualBudget === 'S' ? 'S' : 'N') }
    ];

    useEffect(() => {
        if (isAddAnnualBudget !== 'S') {
            setDtStartUpdateItemCost(null)
            setDtFinishUpdateItemCost(null)
        }
    }, [isAddAnnualBudget]);

    useEffect(() => {
        if (inserting || updating) {
            onUpdateShowFilterMonthPanelItem(false)
        }
        getItemCostRecords()
    }, [inserting, updating, isActiveFilterItems]);


    useEffect(() => {
        if (!reloadItemCost) {
            return
        }
        onUpdateReloadItemCost(false)
        getItemCostRecords()
    }, [reloadItemCost]);

    // A carga inicial e a troca de "ativos" já são feitas pelo efeito de inserting/updating/isActiveFilterItems
    useUpdateEffect(() => {
        onUpdateItemCostIdsSelected([])
        getItemCostRecords()
    }, [comboBoxYear]);

    const setAttributesPanel = async (itemCostIdSelected) => {
        const parameters = { id: itemCostIdSelected }
        const returnItemCostList = await ExecuteAxios.api('get', `/item-cost/items-cost-by-id/`, { params: parameters })
        setItemCostList(returnItemCostList)
        if (returnItemCostList) {
            ApplyAttributes.applyAttributes(returnItemCostList, attributeList)
        }

        if (!itemCostIdSelected || itemCostIdSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    useEffect(() => {
        if (itemCostIdSelected && itemCostIdSelected.length === 1) {
            setAttributesPanel(itemCostIdSelected[0]);
        } else {
            setAttributesPanel(null);
        }
    }, [itemCostIdSelected, updating === true]);

    const userControlPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%'
    };

    async function getItemCostRecords() {
        try {
            const parameter = {
                isActive: isActiveFilterItems,
                currentYear: comboBoxYear
            }
            setLoadingItemCostList(true)
            const itemsCost = await ExecuteAxios.api('get', `/item-cost/list-order-sequence/`, { params: parameter })
            setRecordsItemCost(itemsCost);
            RemoveIdsNotFound.remove(itemsCost, onUpdateItemCostIdsSelected, itemCostIdSelected)
        } finally {
            setLoadingItemCostList(false)
        }
    }

    const itemCostPanelListOrDetail = () => {
        if (!inserting && !updating) {
            return (
                <LoadingIndicator loaded={recordsItemCost && !loadingItemCostList}>
                    <PanelListDefault
                        onUpdateIdSelected={onUpdateItemCostIdsSelected}
                        idsSelected={itemCostIdSelected}
                        data={recordsItemCost}
                        attributeList={attributeList}
                    />
                </LoadingIndicator>
            )
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={itemCostList}
                    attributeList={attributeList}
                    readOnlyAttributes={readOnlyAttributes}
                />
            )
        }
    }

    async function postItemCost() {
        if (itemCostIdSelected && itemCostIdSelected.length === 0) {
            const response = await ExecuteAxios.api('post', `/item-cost/`, {
                dsItem: dsItem,
                dsItemChanged: dsItemChanged,
                idSequence: sequenceId,
                isActive: isActive,
                currentYear: comboBoxYear,
                budgetLimit: budgetLimit,
                isAddAnnualBudget: isAddAnnualBudget,
                dtStartUpdateItemCost: dtStartUpdateItemCost,
                dtFinishUpdateItemCost: dtFinishUpdateItemCost
            });

            if (response) {
                ResetVariables.resetVariables(attributeList);
            }
            return response;
        }
    }

    async function putItemCost() {
        if (itemCostIdSelected && itemCostIdSelected.length === 1) {
            const response = await ExecuteAxios.api('put', `/item-cost/`, {
                id: idItemCost,
                dsItem: dsItem,
                dsItemChanged: dsItemChanged,
                idSequence: sequenceId,
                isActive: isActive,
                userLogged: userIdLogged,
                currentYear: comboBoxYear,
                budgetLimit: budgetLimit,
                isAddAnnualBudget: isAddAnnualBudget,
                dtStartUpdateItemCost: dtStartUpdateItemCost,
                dtFinishUpdateItemCost: dtFinishUpdateItemCost

            });

            if (response) {
                ResetVariables.resetVariables(attributeList);

            }

            return response;
        }
    }

    const styleHistoryChangeButton = {
        width: '85px',
        float: 'right',
        color: getReadOnlyHistoryMonths() ? 'rgba(32, 27, 35, 0.53)' : 'green',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer',
        height: '35px'
    };

    function getHistoryChangeButton() {
        return (
            <Button
                clickMethod={() => { onUpdateShowHistoryChangePanel(true) }}
                buttonName={'Orçamento meses'}
                style={styleHistoryChangeButton}
                disabled={getReadOnlyHistoryMonths()}
            />
        )
    }

    const styleItemsYearReplicate = {
        width: '85px',
        float: 'right',
        color: getReadOnlyReplicateMonths() ? 'rgba(32, 27, 35, 0.53)' : 'green',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer',
        height: '35px'
    };

    function getItemsYearReplicate() {
        return (
            <Button
                clickMethod={() => { onUpdateShowItemsYearReplicate(true) }}
                buttonName={'Replicar itens'}
                style={styleItemsYearReplicate}
                disabled={getReadOnlyReplicateMonths()}
            />
        )
    }

    function getButtons() {
        return (
            <div style={{ display: 'flex', flexDirection: 'row', gap: '4px'}}>
                {getHistoryChangeButton()}
                {getItemsYearReplicate()}
            </div>
        )
    }

    function getReadOnlyHistoryMonths() {
        return (updating || itemCostIdSelected && itemCostIdSelected.length === 0 || showHistoryChangePanel)
    }

    function getReadOnlyReplicateMonths() {
        return (updating || inserting || showItemsYearReplicate)
    }

    return (<>
        <FilterItemCost
            showFilterMonthPanelItem={showFilterMonthPanelItem}
            isActiveFilterItems={isActiveFilterItems}
            comboBoxYear={comboBoxYear}
            onUpdateShowFilterMonthPanelItem={onUpdateShowFilterMonthPanelItem}
            onUpdateIsActiveFilterItems={onUpdateIsActiveFilterItems}
            onUpdateComboBoxYear={onUpdateComboBoxYear}
        />
        <Panel
            titlePage='Itens do orçamento'
            style={userControlPanelStyle}
            setUpdating={setUpdating}
            setInserting={setInserting}
            inserting={inserting}
            updating={updating}
            enableEdit={true}
            canEdit={(itemCostIdSelected && itemCostIdSelected.length === 1) && ![1, 2, 3, 7].includes(itemCostIdSelected[0])}
            putFunction={putItemCost}
            enableNewRecord={true}
            canNewRecord={true}
            postFunction={postItemCost}
            canViewCRUD={true}
            readOnly={false}
            recordsSelected={itemCostIdSelected}
            viewOnlyOneRecordCRUD={true}
            resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
            dataListedAttributes={itemCostList}
            attributeList={attributeList}
            filterAction={(inserting || updating) ? null : onUpdateShowFilterMonthPanelItem}
            componentLeftButtons={getButtons()}
            onUpdateIdSelected={onUpdateItemCostIdsSelected}
        >
            {itemCostPanelListOrDetail()}
        </Panel>
    </>
    );
};

export default ItemCost;


